import { generateRepositoryMethods } from './repository.types.js';
export const productRepositoryMethods = generateRepositoryMethods({
    getProductsAvailabilities: {
        callMethod: 'GET',
        endpoint: '/products/availability',
    },
    getProductsByPharmaCode: {
        callMethod: 'GET',
        endpoint: '/products/pharmacode/search',
    },
    getProductsByGtin: {
        callMethod: 'GET',
        endpoint: '/products/gtin/search',
    },
    calculateGenericSavingPotential: {
        callMethod: 'GET',
        endpoint: '/generic-potential/calculate',
    },
    getOrderablePharmaCodes: {
        callMethod: 'GET',
        endpoint: '/products/orderable/pharma-codes',
    },
    searchProducts: {
        callMethod: 'GET',
        endpoint: '/products/search-with-filters',
    },
});
//# sourceMappingURL=product.methods.js.map